// Helper: Get cookie by name
export const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
};

// ✅ Get authorizationToken (cookie preferred, fallback to localStorage)
export const getAuthToken = () => {
  const cookieToken = getCookie("authorizationToken");
  const localToken = localStorage.getItem("authorizationToken");
  return cookieToken || localToken;
};

// ✅ Get refreshToken (cookie preferred, fallback to localStorage)
export const getRefreshToken = () => {
  const cookieToken = getCookie("refreshToken");
  const localToken = localStorage.getItem("refreshToken");
  return cookieToken || localToken;
};

// ✅ Restore tokens from cookies into localStorage (called once in App.js or _app.js)
export const restoreTokensFromCookies = () => {
  const authToken = getCookie("authorizationToken");
  const refreshToken = getCookie("refreshToken");

  if (authToken && !localStorage.getItem("authorizationToken")) {
    localStorage.setItem("authorizationToken", authToken);
  }

  if (refreshToken && !localStorage.getItem("refreshToken")) {
    localStorage.setItem("refreshToken", refreshToken);
  }
};
